// extracted by mini-css-extract-plugin
export default {"panel":"src-modules-page-blocks-components-SidebarPanel-style__panel_WNQRN","panelBody":"src-modules-page-blocks-components-SidebarPanel-style__panelBody_vdLRx"};